import { FEATURED_LEADERS } from "@/data/siteData";
import { UserRound, Linkedin } from "lucide-react";

export const FeaturedLeaders = () => {
  return (
    <section
      id="featured-leaders"
      data-testid="featured-leaders-section"
      className="border-b border-zinc-200 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 items-end mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="overline text-[#FF2A00] mb-4">/ 05 — Featured Leaders</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase tracking-tighter">
              <span className="text-[#002FA7]">Transformational tech leaders.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4">
            <p className="text-zinc-600">
              Operators, founders and CXOs whose product bets, engineering culture
              and public-good work have moved the industry forward. Felicitated on
              the main stage in front of a curated audience of 500+.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-0 border border-zinc-200">
          {FEATURED_LEADERS.map((l, i) => (
            <a
              key={i}
              href={l.linkedin || "#"}
              target={l.linkedin ? "_blank" : undefined}
              rel={l.linkedin ? "noopener noreferrer" : undefined}
              data-testid={`featured-leader-card-${i}`}
              className="group block p-5 md:p-6 border-r border-b border-zinc-200 [&:nth-child(2n)]:border-r-0 md:[&:nth-child(2n)]:border-r md:[&:nth-child(3n)]:border-r-0 lg:[&:nth-child(3n)]:border-r lg:[&:nth-child(4n)]:border-r-0 hover:bg-zinc-50 transition-colors"
            >
              <div className="aspect-[4/5] w-full overflow-hidden bg-[#0a1a3a] relative mb-4">
                {l.img ? (
                  <img
                    src={l.img}
                    alt={l.name}
                    loading="lazy"
                    className="w-full h-full object-cover object-top"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-white/40 gap-3">
                    <UserRound size={64} strokeWidth={1} />
                    <span className="overline text-[10px] text-white/60 tracking-[0.25em]">
                      Photo · TBA
                    </span>
                  </div>
                )}
                {l.linkedin && (
                  <div className="absolute top-3 right-3 w-8 h-8 bg-white/95 flex items-center justify-center text-[#0A66C2] opacity-0 group-hover:opacity-100 transition-opacity">
                    <Linkedin size={16} strokeWidth={2} />
                  </div>
                )}
              </div>
              <h3 className="font-display text-lg uppercase tracking-tight leading-tight group-hover:text-[#002FA7] transition-colors">
                {l.name}
              </h3>
              <div className="text-xs text-zinc-600 mt-1 leading-snug">{l.title}</div>
              <div className="text-[11px] text-zinc-500 mt-1">{l.org}</div>
              {l.linkedin && (
                <div className="mt-3 inline-flex items-center gap-1.5 overline text-[10px] text-[#0A66C2] tracking-[0.2em]">
                  <Linkedin size={11} strokeWidth={2.5} /> View on LinkedIn →
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedLeaders;
